<div class="field">
  <label for="vehicle-type-select">Vehicle type</label>
  <ng-select
    id="vehicle-type-select"
    [items]="types()"
    bindLabel="name"
    bindValue="name"
    [searchable]="true"
    [clearable]="true"
    [loading]="loading()"
    [placeholder]="
      disabled() ? 'Enter a make and year first' : loading() ? 'Loading vehicle types…' : 'Select a vehicle type'
    "
    [formControl]="control" />
  @if (error()) {
    <p class="field-error">{{ error() }}</p>
  } @else if (!disabled() && !loading() && types().length === 0) {
    <p class="field-hint">No vehicle types found for this make.</p>
  }
</div>
